var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A2550"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35 15.76-5.34 14-2.84-2.84-8.48-8.58 14-5.34A2.14 2.14 0 0 1 35 15.76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 24a20 20 0 1 1-40 0 20 20 0 0 1 40 0M32.24 13l-14 5.34-5.34 14A2.14 2.14 0 0 0 15.76 35l14-5.34L35 15.76A2.14 2.14 0 0 0 32.24 13",
    opacity: 0.6
  }))));
};
export default SvgCompass;